import moment from "moment-timezone";
import { pgpEncrypt } from "./openPGPHelper";

async function handleEncryptData(params) {
	let parseToString = JSON.stringify(params);
	const pgpCipherText = await pgpEncrypt(parseToString);

	return { data: pgpCipherText };
}

async function handleError(error) {
	if (error.response) {
		var errorMessage = "";
		if (error.response.data.error !== undefined) {
			errorMessage = error.response.data.error;
			return errorMessage;
		}
	} else if (error.request) {
		console.log("error.request");
		return error.request;
	} else {
		console.log("error.message");
		console.log(error.message);
		return error.message;
	}
}

function DateTimeFormat(datetime) {
	return moment(datetime).tz("Asia/Singapore").format("DD/MM/YYYY HH-mm-ss");
}

function DateFormat(datetime) {
	return moment(datetime).tz("Asia/Singapore").format("DD/MM/YYYY");
}

function getBase64Promise(file) {
	return new Promise((resolve, reject) => {
		const reader = new FileReader();
		reader.readAsDataURL(file);
		reader.onload = () => resolve(reader.result);
		reader.onerror = (error) => reject(error);
	});
}

function handleGetFileName(file) {
	if (file) {
		const splitArray = file.split("/");
		let newFile = {};
		if (splitArray.length !== 0) {
			const fileName = splitArray.at(-1);
			const newName = fileName.split("_").at(-1);
			const newType = newName.split(".").at(-1);
			newFile = {
				url: file,
				name: newName,
				type: newType,
			};
		} else {
			newFile = {
				url: file,
				name: "couldNoGetFileName",
				type: null,
			};
		}

		return newFile;
	} else return false;
}

export {
	handleEncryptData,
	handleError,
	DateTimeFormat,
	DateFormat,
	getBase64Promise,
	handleGetFileName,
};
